import React, { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams, json } from "react-router-dom";
import { Accordion, Button, Card, Form } from 'react-bootstrap';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import { Static, ShowLoading } from './util.js';
import { User } from './user.js';


function Admin() {

  const store = useSelector((state) => state);
  const navigate = useNavigate();

  let { pw } = useParams();

  let [admin, adminSet] = useState(false);

  let [load, loadSet] = useState(true);

  let [game, gameSet] = useState([]);
  let [lib, libSet] = useState([]);

  useEffect(() => {

    axios.post(Static.SvrAddr + 'dev_admin', {
      pw: pw
    }).then((res) => {
      console.log(res);

      adminSet(res.data[0][0].pass == 1);

      gameSet(res.data[1]);
      libSet(res.data[2]);

      loadSet(false);

    }).catch(() => {
      console.log('실패함');
    })
  }, [])


  function DelLib() {

    axios.post(Static.SvrAddr + 'dev_clean_temp').then((res) => {
      console.log(res);
    }).catch(() => {
      console.log('실패함');
    })

    console.log(game.length + ' / ' + lib.length);

    if (game.length == 0 && lib.length == 0) return;


    let keys = [];
    let lib_id = [];
    let game_id = [];

    game.map((d, i) => {
      game_id.push('"' + d.uid + '"');

      let qz = JSON.parse(d.qz);
      qz.map((dq, i) => {
        if (dq[3] == '@') keys.push('qz/' + d.uid + '_' + i + '-A');
        if (dq[4] == '@') keys.push('qz/' + d.uid + '_' + i + '-B');
      })
    })

    lib.map((d, i) => {
      lib_id.push(d.uid);

      let qz = JSON.parse(d.qz);
      qz.map((dq, i) => {
        if (dq[3] == '@') keys.push('lib/' + d.uid + '_' + i + '-A');
        if (dq[4] == '@') keys.push('lib/' + d.uid + '_' + i + '-B');
      })
    })

    console.log('gid = ' + game_id.toString());
    console.log('lib = ' + lib_id.toString());

    axios.post(Static.SvrAddr + 'dev_clean_sql', {
      game: game_id.toString(),
      lib: lib_id.toString(),
    }).then((res) => {

      if (keys.length > 0) {
        axios.post(Static.SvrAddr + 'dels3', {
          keys: keys,
        }).then((res) => {
          console.log(res);
        }).catch(() => {
          console.log('실패함');
        })
      }

      navigate('/admin');

    }).catch(() => {
      console.log('실패함');
    })

  }



  return (
    <>
      {admin && (
        <>
          <Button variant="primary" onClick={() => { DelLib(); }} >
            게임 {game.length}
            <br></br>
            라이브러리 {lib.length}
            <br></br>
            삭제
          </Button>
        </>
      )}

      {User('all', 'lib', admin)}
    </>

  )
}


export default Admin;
